import React from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import { BookOpen, TrendingUp, Award } from 'lucide-react';

const BASE_URL = process.env.REACT_APP_BASE_URL || 'https://www.echt.gold';

const Magazin = () => {
  const articles = [
    {
      title: 'Goldpreis-Entwicklung 2024: Was Verkäufer wissen sollten',
      category: 'Gold',
      excerpt: 'Der Goldpreis hat 2024 neue Rekordhochs erreicht. Erfahren Sie, was das für Ihren Goldverkauf bedeutet und wann der beste Zeitpunkt zum Verkaufen ist.',
      icon: TrendingUp
    },
    {
      title: 'Luxusuhren als Wertanlage: Diese Modelle sind gefragt',
      category: 'Uhren',
      excerpt: 'Rolex, Patek Philippe und Audemars Piguet - welche Luxusuhren behalten ihren Wert? Ein Überblick über die gefragtesten Modelle auf dem Markt.',
      icon: Award
    },
    {
      title: 'Altgold richtig verkaufen: Tipps für den besten Preis',
      category: 'Ratgeber',
      excerpt: 'Was ist Altgold wert? Wie wird der Wert berechnet? Worauf sollten Sie beim Verkauf achten? Alle wichtigen Informationen im Überblick.',
      icon: BookOpen
    },
    {
      title: 'Diamanten-Bewertung: Die 4C einfach erklärt',
      category: 'Diamanten',
      excerpt: 'Carat, Cut, Color, Clarity - was bedeuten diese Kriterien und wie beeinflussen sie den Wert Ihres Diamanten? Ein verständlicher Leitfaden.',
      icon: Award
    },
    {
      title: 'Zahngold verkaufen: Was Sie wissen müssen',
      category: 'Gold',
      excerpt: 'Zahngold, Kronen und Brücken enthalten wertvolles Edelmetall. So ermitteln Sie den Wert und finden einen seriösen Ankaufer.',
      icon: TrendingUp
    },
    {
      title: 'Silberbesteck erben: Wert ermitteln und verkaufen',
      category: 'Silber',
      excerpt: 'Geerbtes Tafelsilber kann wertvoll sein. Wie Sie Silberbesteck identifizieren, den Wert einschätzen und zum besten Preis verkaufen.',
      icon: BookOpen
    }
  ];

  return (
    <>
      <Helmet>
        <title>Magazin - Tipps & Ratgeber | Echt Gold</title>
        <meta name="description" content="Ratgeber und Tipps rund um Gold und Silber, Luxusuhren und Schmuck. Wissenswertes zu Preisen, Bewertung und Verkauf." />
        <link rel="canonical" href={`${BASE_URL}/magazin`} />
      </Helmet>

      <div className="bg-black/90 py-8 border-b border-gold/20">
        <div className="container mx-auto px-4">
          <div className="text-sm text-gray-400 mb-2">
            <Link to="/" className="hover:text-gold">Home</Link> / <span className="text-gold">Magazin</span>
          </div>
          <h1 className="text-4xl md:text-5xl font-bold gold-text">Magazin & Ratgeber</h1>
        </div>
      </div>

      <section className="section section-dark">
        <div className="container">
          <p className="text-gray-300 text-lg mb-12 text-center max-w-3xl mx-auto">
            Informieren Sie sich über Edelmetalle, Uhren und Schmuck. Unsere Experten teilen ihr Wissen und geben wertvolle Tipps.
          </p>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {articles.map((article, idx) => {
              const Icon = article.icon;
              return (
                <div key={idx} className="card group hover:scale-[1.02] transition-transform" data-testid={`article-${idx}`}>
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-12 h-12 bg-gold/20 rounded-lg flex items-center justify-center">
                      <Icon className="text-gold" size={24} />
                    </div>
                    <span className="text-sm text-gold font-semibold">{article.category}</span>
                  </div>
                  <h3 className="text-xl font-bold mb-3 gold-text group-hover:text-gold/80 transition-colors">
                    {article.title}
                  </h3>
                  <p className="text-gray-300">{article.excerpt}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      <section className="section section-darker">
        <div className="container">
          <div className="card text-center max-w-3xl mx-auto bg-gold/5 border-gold/30">
            <h2 className="text-3xl font-bold mb-4 gold-text">Sie haben Fragen?</h2>
            <p className="text-gray-300 mb-8">
              Unsere Experten beraten Sie gerne persönlich zu allen Themen rund um Edelmetalle, Uhren und Schmuck
            </p>
            <Link to="/kontakt" className="btn-primary">Jetzt Kontakt aufnehmen</Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default Magazin;